import { useEffect, useState } from 'react';

// Returns whether or not the current media query is true.
// Based on https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/useMediaQuery/useMediaQuery.js
const useMediaQuery = (query: string) => {
	const [match, setMatch] = useState(false);

	useEffect(() => {
		let active = true;

		const queryList = window.matchMedia(query);
		const updateMatch = () => {
			if (active) {
				setMatch(queryList.matches);
			}
		};
		updateMatch();
		queryList.addListener(updateMatch);

		return () => {
			active = false;
			queryList.removeListener(updateMatch);
		};
	}, [query]);

	return match;
};

export default useMediaQuery;
